import {
  useCallback,
  useRef,
  useState,
  type MouseEvent,
} from "react";

import { useEscapeKey } from "./useEscapeKey";

export function useEscapeClosableDetails() {
  const summaryRef = useRef<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  useEscapeKey(() => {
    setOpen(false);
    window.requestAnimationFrame(() => summaryRef.current?.focus());
  }, open);

  const onSummaryClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.preventDefault();
      setOpen((current) => !current);
    },
    [],
  );

  return { open, setOpen, summaryRef, onSummaryClick };
}
